import { useState, useEffect } from 'react';
import { useParams, Link } from 'react-router-dom';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import ArticleCard from '@/components/base/ArticleCard';
import Breadcrumb from '@/components/base/Breadcrumb';
import SEOHead from '@/components/base/SEOHead';
import { categories, articles } from '@/mocks/articles';

export default function CategoryPage() {
  const { slug } = useParams<{ slug: string }>();
  const [activeCategory, setActiveCategory] = useState(slug || 'kexue-renzhi');

  useEffect(() => {
    if (slug) setActiveCategory(slug);
    window.scrollTo({ top: 0, behavior: 'instant' });
  }, [slug]);

  const handleCategoryChange = (newSlug: string) => {
    setActiveCategory(newSlug);
    window.scrollTo({ top: 0, behavior: 'instant' });
    window.history.pushState(null, '', `/category/${newSlug}`);
  };

  const currentCat = categories.find((c) => c.slug === activeCategory);
  const categoryArticles = articles.filter((a) => a.category === activeCategory);
  const otherCategories = categories.filter((c) => c.slug !== activeCategory);
  const totalArticles = categoryArticles.length;

  const catName = currentCat?.name || '分类';
  const catDesc = currentCat?.description || '';

  const siteUrl = 'https://bodymindapp.github.io';

  return (
    <>
      <SEOHead
        title={`${catName} | 手淫的科学认知与健康指南`}
        description={`${catDesc}。深入阅读${catName}相关的专业科普文章，了解${catName}领域的科学知识与最新研究。共${totalArticles}篇精选文章。`}
        keywords={`手淫,${catName},性健康教育,科学认知`}
        canonicalUrl={`${siteUrl}/category/${activeCategory}`}
      />
      <Navbar />
      <main className="pt-14">
        <Breadcrumb
          items={[
            { label: '首页', href: '/' },
            { label: catName, href: `/category/${activeCategory}` },
          ]}
        />

        <section className="py-8 md:py-12 px-4 md:px-6 bg-white">
          <div className="max-w-7xl mx-auto">
            <div className="mb-8">
              <h1 className="font-heading text-2xl md:text-3xl font-bold text-foreground-900 mb-2">
                {catName}
              </h1>
              <p className="text-foreground-500">
                {catDesc} — 共 {totalArticles} 篇文章
              </p>
            </div>

            <div className="flex flex-wrap gap-2 mb-8">
              {categories.map((cat) => (
                <button
                  key={cat.slug}
                  onClick={() => handleCategoryChange(cat.slug)}
                  className={`px-4 py-2 rounded-full text-sm font-medium transition-all duration-200 whitespace-nowrap cursor-pointer ${
                    activeCategory === cat.slug
                      ? cat.color === 'primary'
                        ? 'bg-primary-500 text-white'
                        : cat.color === 'accent'
                        ? 'bg-accent-500 text-white'
                        : 'bg-secondary-500 text-white'
                      : 'bg-background-100 text-foreground-600 hover:bg-background-200'
                  }`}
                >
                  {cat.name}
                </button>
              ))}
            </div>

            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
              {categoryArticles.map((article) => (
                <ArticleCard key={article.slug} article={article} />
              ))}
            </div>

            {categoryArticles.length === 0 && (
              <div className="text-center py-16 text-foreground-500">
                该分类暂无文章，请浏览其他分类。
              </div>
            )}
          </div>
        </section>

        {otherCategories.length > 0 && (
          <section className="py-12 md:py-16 px-4 md:px-6 bg-background-100">
            <div className="max-w-7xl mx-auto">
              <h2 className="font-heading text-xl md:text-2xl font-bold text-foreground-900 mb-6">
                浏览其他分类
              </h2>
              <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-5 gap-3">
                {otherCategories.map((cat) => (
                  <Link
                    key={cat.slug}
                    to={`/category/${cat.slug}`}
                    className="p-4 rounded-lg bg-white text-center hover:-translate-y-1 transition-all duration-300 cursor-pointer"
                  >
                    <div
                      className={`w-10 h-10 mx-auto mb-3 rounded-lg flex items-center justify-center ${
                        cat.color === 'primary'
                          ? 'bg-primary-100 text-primary-600'
                          : cat.color === 'accent'
                          ? 'bg-accent-100 text-accent-700'
                          : 'bg-secondary-100 text-secondary-700'
                      }`}
                    >
                      <i className={`${cat.icon} text-lg`}></i>
                    </div>
                    <span className="text-sm font-medium text-foreground-700">
                      {cat.name}
                    </span>
                  </Link>
                ))}
              </div>
            </div>
          </section>
        )}
      </main>
      <Footer />
    </>
  );
}